// Robust clipboard copy helper with fallback for non-secure contexts
// Returns a Promise<boolean> indicating success
export const copyTextToClipboard = async (text) => {
  if (!text) return false;
  // Try the modern async API first (requires secure context)
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // ignore and fall back
  }

  // Fallback to legacy execCommand approach
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 999999);
    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);
    return successful;
  } catch (e) {
    // Last resort: try using selection ranges
    try {
      const selection = window.getSelection && window.getSelection();
      if (!selection) return false;
      const range = document.createRange();
      range.selectNodeContents(document.body);
      selection.removeAllRanges();
      selection.addRange(range);
      const successful = document.execCommand('copy');
      selection.removeAllRanges();
      return successful;
    } catch (err) {
      return false;
    }
  }
};